<template>
  <div>
    <!-- Relatorio Clientes Table -->
    <relatorio-clientes-table
      ref="relatorioClientesTableRef">
    </relatorio-clientes-table>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { log } from '../../utils/DebugLogger';

interface DataTableInstance {
  loadData: () => void;
}

// Reactive data
const relatorioClientesTableRef = ref<DataTableInstance | null>(null);

// Methods
const loadData = async () => {
  if (relatorioClientesTableRef.value) {
    await relatorioClientesTableRef.value.loadData();
  }
};

// Lifecycle
onMounted(() => {
  log('RelatorioClientesPage', 'mounted', 'Component mounted');
});

onBeforeUnmount(() => {
  log('RelatorioClientesPage', 'beforeUnmount', 'Cleaning up');
});

// Expose methods for parent components
defineExpose({
  loadData
});
</script>

<style scoped>
</style>
